import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import CategorySelect from "../forms/CategorySelect";

export default function ModalEditN6({ data, onSave, onCancel }) {
    const [form, setForm] = useState({});

    useEffect(() => {
        if (data) {
            setForm(data);
        }
    }, [data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(form);
    };

    return (
        <Form onSubmit={handleSubmit} className="font-monospace">
            <Row>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>primer_id</Form.Label>
                        <Form.Control type="text" name="primer_id" value={form.primer_id || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>primer_name</Form.Label>
                        <Form.Control type="text" name="primer_name" value={form.primer_name || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={12} className="mb-3">
                    <Form.Group>
                        <Form.Label>sequence_5_to_3</Form.Label>
                        <Form.Control type="text" name="sequence_5_to_3" value={form.sequence_5_to_3 || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>scale</Form.Label>
                        <Form.Control type="text" name="scale" value={form.scale || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>purification</Form.Label>
                        <Form.Control type="text" name="purification" value={form.purification || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>length</Form.Label>
                        <Form.Control type="text" name="length" value={form.length || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>temp_c</Form.Label>
                        <Form.Control type="text" name="temp_c" value={form.temp_c || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>amplification</Form.Label>
                        <Form.Control type="text" name="amplification" value={form.amplification || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>ploymorphism</Form.Label>
                        <Form.Control type="text" name="ploymorphism" value={form.ploymorphism || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={12} className="mb-3">
                    <Form.Group>
                        <Form.Label>image</Form.Label>
                        <Form.Control type="text" name="image" value={form.image || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>rice_cultivar_th</Form.Label>
                        <Form.Control type="text" name="rice_cultivar_th" value={form.rice_cultivar_th || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>rice_cultivar_en</Form.Label>
                        <Form.Control type="text" name="rice_cultivar_en" value={form.rice_cultivar_en || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={12} className="mb-3">
                    <Form.Group>
                        <Form.Label>gs_no</Form.Label>
                        <Form.Control type="text" name="gs_no" value={form.gs_no || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={12} className="mb-3">
                    <Form.Group>
                        <Form.Label>หมวดหมู่ (Category)</Form.Label>
                        <CategorySelect hideOptionAll value={form.category_id || ''} onChange={handleChange} name="category_id" />
                    </Form.Group>
                </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2 mt-3">
                <Button variant="light" onClick={onCancel}>ยกเลิก</Button>
                <Button variant="primary" type="submit">บันทึก</Button>
            </div>
        </Form>
    );
}
